@if (form) {
  <form #formElement [formGroup]="form" #formInstance="ngForm">
    <div class="form" [ngClass]="{ 'form--show-valid': showValidFields, 'form--submitted': this.formState && this.formState.submitted }">
      <div>
        @for (section of controls; track section) {
          <div class="form-section {{ section.additionalClass }}" [hidden]="section.hidden">
            @if (section.title) {
              <h3 class="h2" [ngClass]="{ 'col-12 col-6--md col-4--sm': section.isGrid }">{{ section.title }}</h3>
            }
            @if (section.body) {
              <div
                class="form-section__body"
                [ngClass]="{ 'col-12 col-6--md col-4--sm': section.isGrid }"
                [internalInnerHtml]="section.body"
                [userEventSource]="userEventSource"
              ></div>
            }
            @for (control of section.controls; track control) {
              <air-form-control
                (keydown)="onKeyDown($event)"
                (keyup)="onKeyUp($event)"
                (files)="setFiles($event)"
                (filesBusy)="setFilesBusy($event)"
                [control]="control"
                [group]="form"
                [formState]="formState"
                [showMandatory]="showMandatory"
                [userEventSource]="userEventSource"
                [ngClass]="control.containerClass ? control.containerClass : section.isGrid ? 'col-12 col-6--md col-4--sm' : null"
              ></air-form-control>
            }
          </div>
        }
      </div>
      @if (enableAlternateReCaptcha) {
        <div class="form-group--grecaptcha">
          <air-recaptcha-fallback #reCaptchaFallback></air-recaptcha-fallback>
        </div>
      }
    </div>
    <ng-content></ng-content>
  </form>
}
